var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[_c('b',[_vm._v(_vm._s(_vm.totalSizeBytes))]),_vm._v(" bytes in "),_c('b',[_vm._v(_vm._s(_vm.numFiles))]),_vm._v(" files uploaded so far! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }